<style>
.item {
  cursor: pointer;
  padding: 20px 5px 20px;
}
.item:hover {
  background-color: #09f;
  color: #fff;
}
.item:hover .text--primary {

}
.theme--light.application .text--primary:hover {
  color: #fff !important;
}
</style>

<template>
   <v-container grid-list-md text-xs-center ma-0 pa-0>
     <v-layout row wrap align-center grid-list-md text-xs-center>

        <v-flex xs12 sm3 v-for="(type, index) in types"  v-bind:key="index">
          <v-card text-xs-center align-center class="item" style="padding: 20px" v-on:click="mSetType(type.id)">
                <div>
                  <img alt="" :src="type.src" width="32" height="32">
                </div>
                  <span>{{ type.name }}</span> <br />

                  <v-list-tile-sub-title>
                      {{ type.description }}
                  </v-list-tile-sub-title>
          </v-card>
        </v-flex>
    </v-layout>
    <input v-on:change="handleUpload" type="file" ref="file" style="display: none">
    </v-container>
</template>

<script>
import SpreadSheet from '@/components/data/SpreadSheet.vue';
import SQL from '@/components/data/SQL.vue';
import DataSource from '@/components/data/DataSource.vue';

//import XLSX from 'xlsx';
//alasql.utils.isBrowserify = false;
//alasql.utils.global.XLSX = XLSX;

import {
    createNamespacedHelpers
}
from 'vuex';
const {
    mapState, mapActions, mapGetters, mapMutations
} = createNamespacedHelpers('dataSources')


export default {
    data: function() {
        return {
            code: "/** INSERT SQL BELOW **/",
            connections: [
              {name: "Athena", description: "", src: "/assets/icons/plugins/athena/icons/athena_icon_big.png"},
              {name: "Azure", description: "", src: "/assets/icons/plugins/mssql/icons/azure_icon_big.png"},
              {name: "MariaDB", description: "", src: "/assets/icons/plugins/mysql/icons/mariadb_icon_big.png"},
              {name: "MySQL", description: "", src: "/assets/icons/plugins/mysql/icons/mysql_icon_big.png"},
              {name: "Presto DB", description: "", src: "/assets/icons/plugins/generic/icons/presto_icon_big.png"},
              {name: "MsSQL", description: "", src: "/assets/icons/plugins/mssql/icons/mssql_icon_big.png"},
              {name: "SyBase", description: "", src: "/assets/icons/plugins/mssql/icons/sybase_icon_big.png"},
              {name: "PostrgeSQL", description: "", src: "/assets/icons/plugins/postgresql/icons/postgresql_icon_big.png"},
              {name: "Cocroach DB", description: "", src: "/assets/icons/plugins/postgresql/icons/cockroach_icon_big.png"},
              {name: "Timescale", description: "", src: "/assets/icons/plugins/postgresql/icons/timescale_icon_big.png"},
              {name: "Redshift", description: "", src: "/assets/icons/plugins/postgresql/icons/redshift_icon_big.png"},
              {name: "Yellow Brock", description: "", src: "/assets/icons/plugins/postgresql/icons/yellowbrick_icon_big.png"}
            ]
          }

    },
    methods: {
        ...mapMutations(['mSetType']),
        ...mapActions(['aAdd', 'aSetDataSource']),
        handleUpload(e) {}
    },
    computed: {
        ...mapState(['types', 'dataSource'])
    },
    components: {
      'spread-sheet': SpreadSheet,
      'sql' : SQL,
      'data-source': DataSource
    },

}

</script>
